<template>
  <div class="open-account-step">
    <p class="title">{{ $t('openInstitutionServices.g000005') }}</p>
    <div class="step-box">
      <div class="item active">
        <p class="tit">{{ step1Text || $t('openInstitutionServices.g000006')}}</p>
        <p class="sub light fwb">{{ $t('openInstitutionServices.g000007') }}{{statusText || $t('openInstitutionServices.g000016')}}</p>
      </div>
      <div class="item">
        <p class="tit fwb">{{ $t('openInstitutionServices.g000008') }}</p>
        <p class="sub small">
          {{ $t('openInstitutionServices.g000009') }}
          <span class="light">{{ $t('openInstitutionServices.g000010') }}</span>{{ $t('openInstitutionServices.g000011') }}<span class="light">{{ $t('openInstitutionServices.g000012') }}</span>{{ $t('openInstitutionServices.g000013') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script >
export default {
  props: {
    step1Text: {
      default: '',
      type: String
    },
    statusText: {
      default: '',
      type: String
    }
  },
}
</script>

<style scoped lang="less">
.open-account-step{
  padding: 0 26px 26px;
  background: #EEF1F9;
  border-radius: 24px;
  text-align: left;
  .title{
    height: 84px;
    padding: 4px 16px 0;
    line-height: 88px;
    color: #17161C;
    font-size: 32px;
    font-weight: 500;
  }
  .step-box{
    background: #fff;
    border-radius: 20px;
    padding: 24px 34px;
    .item{
      padding-left: 64px;
      padding-bottom: 44px;
      position: relative;
      &::before,&::after{
        position: absolute;
        content: '';
      }
      &::before{
        left: 0;
        top: 0;
        width: 40px;
        height: 40px;
        background: url("../assets/images/open-account-step-icon-default.png") no-repeat;
        background-size: 100% 100%;
        z-index: 3;
      }
      &::after{
        left: 19px;
        top: 0;
        bottom: 0;
        width: 1px;
        height: 100%;
        background-image: repeating-linear-gradient(
          to bottom,
          #EEF1F9 0,
          #EEF1F9 4px,
          transparent 4px,
          transparent 8px
        );
        background-size: 1px 8px;
      }
      &.active{
        &:before{
          background: url("../assets/images/open-account-step-icon-active.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      &:last-child{
        padding-bottom: 0;
        &::after{
          display: none;
        }
      }
      .tit{
        line-height: 40px;
        font-size: 28px;
        font-weight: 500;
      }
      .sub{
        font-size: 28px;
        margin-top: 4px;
      }
      .light{
        color: #F24E1E;
      }
      .fwb{
        font-weight: 500;
      }
      .small{
        font-size: 24px;
        line-height: 30px;
      }
    }
  }
}
.black-theme{
  .open-account-step{
    background: #313D5D;
    .title{
      color: #fff;
    }
    .step-box{
      background: #1C2338;
      color: #fff;
    }
  }
}
</style>